<template>
  <!-- <div style="background-color: #fff; padding: 10px"> -->
  <!-- 搜索 -->
  <div ref="topDom" class="header-bar">
    <div class="bar-lef">
      <div class="lef-group">
        <div class="group-one">
          <a-select
              v-model:value="searchForm.status"
              allowClear
              placeholder="状态"
              @change="getTableData"
          >
            <a-select-option :value="1">启用</a-select-option>
            <a-select-option :value="2">停用</a-select-option>
            <a-select-option :value="3">待启用</a-select-option>
          </a-select>
        </div>
      </div>
      <div class="lef-group">
        <div class="group-one">
          <a-select
              v-model:value="searchForm.report_status"
              allowClear
              placeholder="同步状态"
              @change="getTableData"
          >
            <a-select-option :value="0">待上报</a-select-option>
            <a-select-option :value="1">上报中</a-select-option>
            <a-select-option :value="2">上报成功</a-select-option>
            <a-select-option :value="3">上报失败</a-select-option>
          </a-select>
        </div>
      </div>
      <div class="lef-one" style="width: 300px">
        <a-input-search
            v-model:value="searchForm.keyword"
            :loading="searchLoading"
            allowClear
            placeholder="房间名称/地址/经营者/门店名称"
            @search="getTableData"
        ></a-input-search>
      </div>
      <div class="lef-one">
        <a-input-search
            v-model:value="searchForm.policeStation"
            :loading="searchLoading"
            allowClear
            placeholder="派出所"
            @search="getTableData"
        ></a-input-search>
      </div>
    </div>
  </div>

  <!-- 表格 -->
  <a-table
      :columns="columns"
      :dataSource="dataSource"
      :loading="searchLoading"
      :pagination="false"
      :scroll="{ x: columns.length > 8 ? columns.length*130 : 0, y: tableHeight }"
      class="table"
      size="small"
  >
    <template #bodyCell="{ column, record }">
      <template v-if="column.key == 'status_text'">
        <span v-if="record.status == 1">{{ record.status_text }}</span>
        <span v-else class="f-c-red">{{ record.status_text }}</span>
      </template>
      <template v-if="column.key == 'operation'">
        <a-button
            v-if="record.status == 1"
            type="link"
            @click="handleEditStatus(record, 2)"
        >停用
        </a-button
        >
        <a-button v-else type="link" @click="handleEditStatus(record, 1)"
        >启用
        </a-button
        >
        <a-button type="link" @click="handleEdit(record)">修改</a-button>
        <a-button type="link" @click="handleSyn(record)">同步</a-button>
      </template>
    </template>
  </a-table>

  <!-- 弹窗 -->
  <a-modal
      v-model:visible="visibleAdd"
      :title="modalTitle"
      :width="500"
      @ok="addSave"
  >
    <a-form
        ref="formRef"
        :label-col="{ span: 6 }"
        :model="addForm"
        :rules="rules"
        hideRequiredMark
        labelAlign="left"
    >
      <a-form-item label="上报名称：" name="roomNo">
        <a-input
            v-model:value="addForm.roomNo"
            placeholder="请输入房间名称"
            style="width: 100%"
        ></a-input>
        <span class="f-c-red">名称在10个字以内：如1栋701</span>
      </a-form-item>
      <a-form-item label="床位数：" name="bedNum">
        <a-input
            v-model:value="addForm.bedNum"
            placeholder="请输入床位数"
            style="width: 100%"
        ></a-input>
      </a-form-item>
      <a-form-item label="房源地址：" name="room_address">
        <a-input
            v-model:value="addForm.room_address"
            placeholder="请输入房源地址"
            style="width: 100%"
        ></a-input>
      </a-form-item>
      <a-form-item class="f-item" label="所属派出所：">
        <StationSelect
            :class="{ areaSel: addForm.id }"
            :placeholder="addForm.stationPlaceholder"
            style="width: 100%"
            @changeStation="changeStation"
        />
      </a-form-item>
    </a-form>
  </a-modal>

  <!-- 分页 -->
  <MyPagination
      :pageTotal="pageTotal"
      class="pagination"
      @onShowSizeChange="onShowSizeChange"
      @pageChange="pageChange"
  />
  <!-- </div> -->
</template>

<script>
import {createVNode, nextTick, onMounted, reactive, toRefs, watch} from "vue";
import {guotaiHouseEdit, guotaiHouseList, guotaiHouseStatus, guotaiHouseSyn,} from "@/api/api";
import useUtils from "@/hooks/useUtils.js"; //工具库
import store from "@/store/pms/landlord/index"; //VUEX
import {message, Modal} from "ant-design-vue";
import {ExclamationCircleOutlined} from "@ant-design/icons-vue";
import StationSelect from "@/components/pms/landlord/AreaSelect/StationSelect.vue";

export default {
  components: {StationSelect},
  setup() {
    let {countTable, imgCut} = useUtils();
    // 搜索
    const search = reactive({
      topDom: "",
      searchLoading: false,
      searchForm: {
        keyword: "",
        policeStation: "",
        status: [],
        report_status: [],
        start: 0,
        limit: store.getters.getPageSize,
      },
    });

    // 表格
    const table = reactive({
      tableHeight: "",
      dataSource: [],
      initColumns: [],
      columns: [
        {
          title: "序号",
          dataIndex: "id",
          key: "id",
          width: 100,
          align: "center",
        },
        {
          title: "房间名称",
          dataIndex: "name",
          key: "name",
          width: 150,
          ellipsis: true,
          align: "center",
        },
        {
          title: "上报名称",
          dataIndex: "roomNo",
          key: "roomNo",
          align: "center",
          width: 150,
        },
        {
          title: "网约房挂牌名称",
          dataIndex: "realName",
          key: "realName",
          align: "center",
          width: 150,
        },
        {
          title: "经营者",
          dataIndex: "masterName",
          key: "masterName",
          align: "center",
          width: 100,
        },
        {
          title: "手机号码",
          dataIndex: "masterMobile",
          key: "masterMobile",
          align: "center",
          width: 100,
        },
        {
          title: "房源详细地址（全量地址）",
          dataIndex: "gname",
          key: "gname",
          width: 300,
          customRender: ({record}) => {
            return (
                record.province_name +
                record.city_name +
                record.area_name +
                record.address +
                record.roomNo
            );
          },
        },
        {
          title: "派出所",
          dataIndex: "policeAreaName",
          key: "policeAreaName",
          align: "center",
          width: 150,
        },
        {
          title: "苏安码",
          dataIndex: "report_code",
          key: "report_code",
          align: "center",
          width: 200,
        },
        {
          title: "同步状态",
          dataIndex: "report_status_text",
          key: "report_status_text",
          width: 80,
          align: "center",
        },
        {
          title: "同步时间",
          dataIndex: "start_time_str",
          key: "start_time_str",
          width: 150,
          align: "center",
          customRender: ({record}) => {
            if (record.syn_time > 0) {
              return record.syn_time_str;
            } else {
              return '-';
            }
          },
        },
        {
          title: "备注",
          dataIndex: "remark",
          key: "remark",
          width: 200,
          align: "center",
          ellipsis: true,
        },
        {
          title: "状态",
          dataIndex: "status_text",
          key: "status_text",
          width: 80,
          align: "center",
        },
        {
          title: '苏州公安上报状态',
          dataIndex: 'szga_report_status',
          key: 'szga_report_status',
          width: 150,
          customRender({ record }) {
            const statusMap = {
              0: '待上报',
              1: '上报中',
              2: '上报成功',
              3: '上报失败',
            };
            return statusMap[record.szga_report_status] ?? record.szga_report_status_text ?? '-';
          },
        },
        {
          title: "启用时间",
          dataIndex: "start_time_str",
          key: "start_time_str",
          width: 150,
          align: "center",
          customRender: ({record}) => {
            if (record.start_time > 0) {
              return record.start_time_str;
            } else {
              return '-';
            }
          },
        },
        {
          title: "停用时间",
          dataIndex: "stop_time_str",
          key: "stop_time_str",
          width: 150,
          align: "center",
          customRender: ({record}) => {
            if (record.stop_time > 0) {
              return record.stop_time_str;
            } else {
              return '-';
            }
          },
        },
        {
          title: "创建时间",
          dataIndex: "create_time",
          key: "create_time",
          width: 160,
          align: "center",
          ellipsis: true,
        },
        {
          title: "操作",
          dataIndex: "operation",
          key: "operation",
          align: "center",
          width: 150,
          fixed: 'right'
        },
      ],
      handleEditStatus(item, status) {
        let text = status == 2 ? "停用" : "启用";
        Modal.confirm({
          title: `是否${text}？`,
          icon: createVNode(ExclamationCircleOutlined),
          centered: true,
          onOk() {
            guotaiHouseStatus({id: item.id, status: status}).then((res) => {
              message.success(res.msg);
              table.getTableData();
            });
          },
        });
      },
      handleSyn(item) {
        Modal.confirm({
          title: `是否上报同步？`,
          icon: createVNode(ExclamationCircleOutlined),
          centered: true,
          onOk() {
            guotaiHouseSyn({id: item.id}).then((res) => {
              message.success(res.msg);
              table.getTableData();
            });
          },
        });
      },
      getTableData() {
        search.searchLoading = true;
        guotaiHouseList(search.searchForm)
            .then((res) => {
              table.dataSource = res.data.list;
              pagination.pageTotal = res.data.count;
              search.searchLoading = false;
            })
            .catch(() => {
              search.searchLoading = false;
            });
      },
      handleEdit(item) {
        modal.modalTitle = "修改信息";
        nextTick(() => {
          modal.addForm.roomNo = item.roomNo;
          modal.addForm.bedNum = item.bedNum;
          modal.addForm.id = item.id;
          modal.addForm.policeAreaCode = item.policeAreaCode;
          modal.addForm.policeAreaName = item.policeAreaName;
          modal.addForm.room_address = item.room_address;
          modal.addForm.stationPlaceholder = item.policeAreaName;
        });
        modal.visibleAdd = true;
        console.log('22222', modal.addForm)
      },
    });

    // 弹窗
    const modal = reactive({
      modalTitle: "",
      visibleAdd: false,
      formRef: "", //表单验证
      addForm: {
        id: "",
        roomNo: "",
        policeAreaCode: "",
        policeAreaName: "",
        bedNum: "",
        room_address: "",
        stationPlaceholder: "",
      },
      rules: {
        roomNo: [
          {
            required: true,
            message: "请输入房间名称",
            trigger: "blur",
          },
        ],
        policeAreaCode: [
          {
            required: true,
            message: "请选择派出所",
            trigger: "blur",
          },
        ],
        policeAreaName: [
          {
            required: true,
            message: "请选择派出所",
            trigger: "blur",
          },
        ],
      },
      // 保存
      isLoading: false,
      addSave() {
        if (modal.isLoading) {
          return;
        }
        modal.formRef.validate().then(() => {
          modal.isLoading = true;
          console.log(modal.addForm)
          guotaiHouseEdit(modal.addForm)
              .then((res) => {
                message.success(res.msg);
                nextTick(() => {
                  modal.isLoading = false;
                });
                modal.visibleAdd = false;
                table.getTableData();
              })
              .catch(() => {
                modal.isLoading = false;
              });
        });
      },

      // 选择派出所回调
      changeStation(params) {
        console.log('22222', params)
        // Object.assign(modal.addForm, params);
        modal.addForm.policeAreaCode = params.a_code;
        modal.addForm.policeAreaName = params.a_name;
        modal.addForm.stationPlaceholder = params.a_name;
      },
      throttle: false,
      throttleInput: "",
    });

    // 分页;
    let pagination = reactive({
      pageTotal: 0,
      pageChange(value) {
        search.searchForm.start = (value - 1) * search.searchForm.limit;
        table.getTableData();
      },
      onShowSizeChange(value) {
        search.searchForm.limit = value;
        table.getTableData();
      },
    });

    watch(
        () => store.state.ContentHeight,
        () => {
          table.tableHeight = countTable(search.topDom) - 100;
        }
    );

    onMounted(() => {
      table.getTableData();
      table.tableHeight = countTable(search.topDom) - 100;
    });

    return {
      ...toRefs(search),
      ...toRefs(table),
      ...toRefs(modal),
      ...toRefs(pagination),
      imgCut,
    };
  },
};
</script>

<style lang="scss">
.weixin {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  .QR {
  }

  .info {
    font-weight: bold;
  }

  .tips {
    color: #f5a623;
    margin-top: 20px;
  }
}

.drawer {
  position: absolute;

  .header {
    height: 60px;
    border-bottom: 1px solid #f2f2f2;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 20px;

    .title {
    }

    .status {
    }
  }

  .content {
    padding: 20px;

    .title {
      padding: 10px 0;
    }

    .info {
      display: flex;
      padding: 7px 0;

      .lef {
        width: 100px;
      }

      .rig {
        width: 400px;
      }
    }
  }

  .operate {
    display: flex;
    justify-content: space-between;
    align-items: center;
    position: fixed;
    bottom: 0;
    width: 450px;
    height: 60px;
    border-top: 1px solid #f2f2f2;
    background-color: #fff;

    .lef {
    }

    .rig {
    }
  }
}

.fRed {
  color: red;
}

.bar {
  border-radius: 10px;
  padding: 2px 10px;
  height: 20px;
  width: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #ffffff;
  font-size: 12px;
}

.add-box {
  width: 100%;
  display: flex;
  // justify-content: space-between;
  padding: 0 10px;

  .add-lef {
    flex: 1;
    margin-right: 40px;
  }

  .add-rig {
    flex: 1;
  }
}

.checkbox {
  margin-left: 90px;
  margin-bottom: 24px;
}
</style>
